(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-tabbed-collections-tab]');
    if (tab) {
      var wrap = tab.closest('[data-tabbed-collections]');
      if (!wrap) return;
      wrap.querySelectorAll('[data-tabbed-collections-tab]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      tab.classList.add('is-active');
      var targetId = tab.getAttribute('data-tab-target');
      wrap.querySelectorAll('[data-tabbed-collections-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.id === targetId);
      });
      return;
    }

    var arrow = event.target.closest('[data-tabbed-collections-arrow]');
    if (arrow) {
      var wrapper = arrow.closest('[data-tabbed-collections]');
      if (!wrapper) return;
      var activePanel = wrapper.querySelector('[data-tabbed-collections-panel].is-active');
      if (!activePanel) return;
      var track = activePanel.querySelector('[data-tabbed-collections-track]');
      if (!track) return;
      var amount = track.clientWidth * 0.9;
      var isNext = arrow.classList.contains('tabbed-collections__arrow--next');
      track.scrollBy({ left: isNext ? amount : -amount, behavior: 'smooth' });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
